import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack, Grid, FormControl, FormLabel, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import axios from 'axios';
import { APIURL } from '../../../config';

const BillingSettings = (props) => {
    const FEATURE_ID = 70;
    const [featureValue, setFeatureValue] = useState('month');

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: FEATURE_ID } })).data;

            if (settingsData.length > 0) {
                setFeatureValue(settingsData[0].feature_value);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleInputChange = async (e) => {
        const newValue = e.target.value;

        try {
            setFeatureValue(newValue);
            const settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: FEATURE_ID } })).data;

            if (settingsData.length > 0) {
                await axios.put(APIURL + `/config/settings`, {
                    settings_id: settingsData[0].settings_id,
                    feature_value: newValue,
                    feature_id: FEATURE_ID,
                });
            } else {
                await axios.post(APIURL + `/config/settings`, {
                    feature_value: newValue,
                    feature_id: FEATURE_ID,
                    company_id: props.comp_id,
                    added_by: props.user_id
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={29}>
                <Grid item xs={4}>
                    <Stack spacing={1}>
                        <Typography variant="h5">
                            {'Billing Settings'}
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'gray' }}>
                            {'Other Billing related settings'}
                        </Typography>
                    </Stack>
                </Grid>
                <Grid size={8}>
                    <Stack spacing={1}>
                        <FormControl>
                            <FormLabel>{'Prior Authorization Date Range View'}</FormLabel>
                            <RadioGroup
                                row
                                value={featureValue}
                                onChange={handleInputChange}
                            >
                                <FormControlLabel value="month" control={<Radio />} label="Month" />
                                <FormControlLabel value="week" control={<Radio />} label="Week" />
                            </RadioGroup>
                        </FormControl>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BillingSettings;